module.exports = __webpack_public_path__ + "img/detail-5.5dcb855c.jpg";